import { isBefore, addHours, startOfDay } from 'date-fns';

function isBeforeNoon(date) {
  var noon = addHours(startOfDay(date), 12);
  return isBefore(date, noon);
}

export { isBeforeNoon };
